<style lang="scss" scoped>
@media screen and (max-width: 740px) {
  .employees-form-sabbatical {
    margin-top: 20px !important;
  }
  .mobile-input {
    margin-top: 20px;
  }
  .save-info {
    margin-right: 0 !important;
    padding: 7px !important;
    display: block;
    width: 100%;
  }
  .cancel-employee {
    padding: 7px 30px !important;
    font-weight: 600;
    background: #f6f6f6;
    border: 2px solid #0d2e48;
    color: #0d2e48;
    width: 100%;
    margin-top: 5px;
  }
  .sabbatical-leave {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  p.note {
    margin-bottom: 5px;
  }
  .mobile-input {
    margin-top: 20px;
  }
}
.employees-sabbatical-leave {
  .title-header {
    font-size: 18px;
  }

  .save-info {
    background: #b4daf3;
    font-weight: 600;
    padding: 7px 70px;
    color: #0d2e48;
    margin-right: 20px;
    border: 2px solid #b4daf3;
  }

  label {
    font-weight: 600;
  }

  .input-group {
    margin-bottom: 0px !important;
  }

  .row {
    margin-bottom: 20px;
  }

  .cancel-employee {
    padding: 7px 45px;
    font-weight: 600;
    background: #f6f6f6;
    border: 2px solid #0d2e48;
    color: #0d2e48;
  }

  span.require {
    color: #ff1a1a;
  }

  span.required {
    color: #ff1a1a;
    margin-top: -15px;
  }

  .form-group {
    margin-bottom: 0px;
  }

  .employees-form-sabbatical {
    text-align: center;
    margin-top: 15px;
  }

  .sabbatical-leave {
    margin: auto !important;
  }

  p.note {
    font-weight: 700;
    color: #ff1a1a;
  }
  .note-link {
    cursor: pointer;
  }
}
</style>

<template>
  <CContainer class="employees-sabbatical-leave">
    <ValidationObserver ref="formSabbaticalEmployee" v-slot="{ handleSubmit }">
      <CRow>
        <CCol :md="{ size: '10', offset: '2' }" class="sabbatical-leave">
          <CCard>
            <CCardHeader>
              <label class="title-header">{{
                $t("sabbatical.label_title")
              }}</label>
              <br /><br />
              <label>{{ $t("commons.note") }}</label>
              <p class="note">
                {{ $t("sabbatical.choose_time", { 
                  morning_shift_start: account.work_shift.morning_shift_start.slice(0, 5), 
                  morning_shift_end: account.work_shift.morning_shift_end.slice(0, 5), 
                  afternoon_shift_start: account.work_shift.afternoon_shift_start.slice(0, 5), 
                  afternoon_shift_end: account.work_shift.afternoon_shift_end.slice(0, 5) 
                }) }}
              </p>
              <p class="note" v-if="forms.reason_type == 4">
                {{ $t("sabbatical.the_rest_minutes_can_be_registered") }}
                {{ dataCommons.number_minutes_off_physiology_rest_real }}
              </p>
              <p class="note" v-if="forms.reason_type == 4">
                {{ $t("sabbatical.the_rest_records_can_be_registered") }}
                {{ dataCommons.number_sabbatical_physiological_request_can_create_in_month}}
              </p>
              <p class="note" v-if="forms.reason_type != 4">
                {{ $t("sabbatical.time_real") }}
                {{ dataCommons.all_time_days_off_sabbatical_rest_real }}
              </p>
              <p class="note-link note" @click="linkToGuide()">
                {{ $t("commons.regulations_of_the_company_on_leave_here") }}
              </p>
            </CCardHeader>
            <CCardBody>
              <CForm
                class="create_form"
                @submit.prevent="handleSubmit(createSabbaticalRequest)"
              >
                <CRow>
                  <CCol md="6" class="form-field">
                    <label>
                      {{ $t("employee.label_employee_code") }}
                    </label>
                    <CInput
                      type="text"
                      :disabled="true"
                      v-model="dataCommons.id"
                    />
                  </CCol>

                  <CCol md="6" class="form-field mobile-input">
                    <label>
                      {{ $t("employee.label_employee_name") }}
                    </label>
                    <CInput
                      type="text"
                      :disabled="true"
                      v-model="dataCommons.name"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="6" class="form-field">
                    <label>
                      {{ $t("employee.label_employee_foot") }}
                    </label>
                    <CInput
                      type="text"
                      :disabled="true"
                      v-model="dataCommons.foot"
                    />
                  </CCol>

                  <CCol md="6" class="form-field mobile-input">
                    <label>
                      {{ $t("employee.label_employee_division") }}
                    </label>
                    <CInput
                      type="text"
                      :disabled="true"
                      v-model="dataCommons.division"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="6" class="form-field">
                    <label>
                      {{ $t("commons.label_approve_person1") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="overtime.approve"
                    >
                      <select
                        class="form-control"
                        v-model="forms.approve_person_1"
                      >
                        <template v-if="forms.reason_type != 4">
                          <option
                            v-for="(option, index) in approveEmployees['level1']"
                            :key="index"
                            :value="option.id"
                          >
                            {{ option.name }}
                          </option>
                        </template>
                        <template v-else>
                           <option
                            v-for="(option, index) in admins"
                            :key="index"
                            :value="option.id"
                          >
                            {{ option.name }}
                          </option>
                        </template>
                      </select>
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>

                  <CCol
                    md="6"
                    class="form-field mobile-input"
                    v-if="
                      approveEmployees['level2'] &&
                      approveEmployees['level2'].length > 0 &&
                      forms.reason_type != 4
                    "
                  >
                    <label>
                      {{ $t("commons.label_approve_person2") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="overtime.approve2"
                    >
                      <select
                        class="form-control"
                        v-model="forms.approve_person_2"
                      >
                        <option
                          v-for="(option, index) in approveEmployees['level2']"
                          :key="index"
                          :value="option.id"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="6" class="form-field">
                    <label>
                      {{ $t("sabbatical.reason") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="sabbatical.reason"
                    >
                      <select class="form-control" v-model="forms.reason_code">
                        <option value="">
                          {{ $t("employee.select_option") }}
                        </option>
                        <option
                          v-for="(option, index) in reasonsFilter"
                          :key="index"
                          :value="option.code"
                        >
                          {{ option.reason }}
                        </option>
                      </select>
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>

                  <CCol md="6" class="form-field mobile-input">
                    <label>
                      {{ $t("sabbatical.type_reason") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="sabbatical.type_reason"
                    >
                      <select class="form-control" v-model="forms.reason_type" @change="changeReasonTypeToPhysiologicalLeave">
                        <option value="">
                          {{ $t("employee.select_option") }}
                        </option>
                        <option value="1">
                          {{ $t("sabbatical.type_reason_1") }}
                        </option>
                        <option value="2">
                          {{ $t("sabbatical.type_reason_2") }}
                        </option>
                        <option value="3">
                          {{ $t("sabbatical.type_reason_3") }}
                        </option>

                        <option value="4" v-if="account.gender === female">
                          {{ $t("sabbatical.type_reason_4") }}
                        </option>

                      </select>
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="6" class="form-field">
                    <label>
                      {{ $t("label.start_time") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      :rules="{
                        required: true,
                        regex: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
                        between_time_start_time: account.work_shift.morning_shift_start.slice(0, 5),
                        less_end_time: {
                          start_date: forms.start_date,
                          end_date: forms.end_date,
                          end_time: forms.end_time,
                        },
                        start_time_is_not_fit: true,
                      }"
                      v-slot="{ errors }"
                      name="sabbatical.start_time"
                    >
                      <b-form-input
                        type="text"
                        v-mask="'##:##'"
                        placeholder="HH:mm"
                        v-model="forms.start_time"
                        v-on:keyup="calculateDaySabbatical"
                      />
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                  <CCol md="6" class="form-field mobile-input">
                    <label>
                      {{ $t("commons.label_start_date") }}
                      <span class="require">*</span>
                    </label>
                    <DatePickerForm
                      :propsDate="forms.start_date ? forms.start_date : ''"
                      v-on:emitDate="startDate"
                      :max-date="maxDateBeforeApril4"
                      :rules="{
                        required_date: true,
                        regex:
                          /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/,
                        between_time_start_date: forms.end_date,
                        month_is_curent_month: {
                          start_date: forms.start_date,
                          reason_type: forms.reason_type == 4 ? true : false
                        }

                      }"
                      :name="'fields.sabbatical.label_start_date'"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="6" class="form-field">
                    <label>
                      {{ $t("label.end_time") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      :rules="{
                        required: true,
                        regex: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
                        between_time_end_time: account.work_shift.afternoon_shift_end.slice(0, 5),
                        fewer_start_time: {
                          start_time: forms.start_time,
                          start_date: forms.start_date,
                          end_date: forms.end_date,
                        },
                        end_time_is_not_fit: true,
                        end_time_is_too_long_for_physiological_leave_from_start_time: {
                          start_time: forms.start_time,
                          end_time: forms.end_time,
                          reason_type: forms.reason_type == 4 ? true : false
                        }

                      }"
                      v-slot="{ errors }"
                      name="sabbatical.end_time"
                    >
                      <b-form-input
                        type="text"
                        v-mask="'##:##'"
                        placeholder="HH:mm"
                        v-model="forms.end_time"
                        v-on:keyup="calculateDaySabbatical"
                      />
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                  <CCol md="6" class="form-field mobile-input">
                    <label>
                      {{ $t("commons.label_end_date") }}
                      <span class="require">*</span>
                    </label>
                    <DatePickerForm
                      :propsDate="forms.end_date ? forms.end_date : ''"
                      v-on:emitDate="endDate"
                      :max-date="maxDateBeforeApril4"
                      :rules="{
                        required_date: true,
                        regex:
                          /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/,
                        between_time_end_date: forms.start_date,
                        end_date_is_not_same_start_date: {
                          start_date: forms.start_date,
                          end_date: forms.end_date,
                          reason_type: forms.reason_type == 4 ? true : false
                        },
                        month_is_curent_month: {
                          end_date: forms.end_date,
                          reason_type: forms.reason_type == 4 ? true : false
                        }
                      }"
                      :name="'fields.sabbatical.label_end_date'"
                    />
                  </CCol>
                </CRow>
                <CRow v-if="forms.reason_type != 4">
                  <CCol md="4" class="form-field">
                    <label>
                      {{ $t("sabbatical.number_days_off") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      :rules="{
                        required: true,
                        min_value: minShiftDuration,
                        less_number_of_days_off_rest: {
                          reason_type: forms.reason_type,
                          number_of_days_off_rest:
                            dataCommons.number_of_days_off_rest,
                        },
                      }"
                      ref="numberDaysOff"
                      v-slot="{ errors }"
                      name="sabbatical.number_days_off"
                    >
                      <CInput
                        type="text"
                        v-model="forms.number_days_off"
                        :disabled="true"
                      />
                      <span class="required">{{ errors[0] }}</span>
                      <br />
                      <span
                        class="required custom"
                        v-if="
                          forms.number_days_off >
                            dataCommons.all_time_days_off_sabbatical_rest_real &&
                          forms.reason_type === '1'
                        "
                        >{{ $t("sabbatical.time_real") }}
                        {{
                          dataCommons.all_time_days_off_sabbatical_rest_real
                        }}</span
                      >
                    </ValidationProvider>
                  </CCol>

                  <CCol md="4" class="form-field">
                    <label>
                      {{ $t("sabbatical.number_of_days_off") }}
                    </label>
                    <CInput
                      type="text"
                      :disabled="true"
                      v-model="dataCommons.number_of_days_off"
                    />
                  </CCol>
                  <CCol md="4" class="form-field mobile-input">
                    <label>
                      {{ $t("sabbatical.number_of_days_off_rest") }}
                    </label>
                    <CInput
                      type="text"
                      :disabled="true"
                      v-model="dataCommons.number_of_days_off_rest"
                    />
                  </CCol>
                </CRow>
                <!-- Physiological leave -->
                <CRow v-else>
                  <CCol md="4" class="form-field">
                    <label>
                      {{ $t("sabbatical.number_minutes_off") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      :rules="{
                        required: true,
                        min_value: 1,
                        max_value: 90,
                        less_than_minutes_can_request: {
                          time_request: Math.round(forms.number_days_off * 8 * 60),
                          max_time_request:  dataCommons.number_minutes_off_physiology_rest_real
                        },
                        less_than_times_can_request: {
                          max_times_can_request:  dataCommons.number_sabbatical_physiological_request_can_create_in_month
                        }
                      }"
                      ref="numberDaysOff"
                      v-slot="{ errors }"
                      name="sabbatical.number_minutes_off"
                    >
                      <CInput
                        type="text"
                        :value="Math.round(forms.number_days_off * 8 * 60)"
                        :disabled="true"
                      />
                      <span class="required">{{ errors[0] }}</span>
                      <br />
                      <span
                        class="required custom"
                        v-if="
                          forms.number_days_off >
                            dataCommons.all_time_days_off_sabbatical_rest_real &&
                          forms.reason_type === '1'
                        "
                        >{{ $t("sabbatical.time_real") }}
                        {{
                          dataCommons.all_time_days_off_sabbatical_rest_real
                        }}</span
                      >
                    </ValidationProvider>
                  </CCol>

                  <CCol md="4" class="form-field">
                    <label>
                      {{ $t("sabbatical.number_of_minutes_off") }}
                    </label>
                    <CInput
                      type="text"
                      :disabled="true"
                      :value="numberMinutesPhysiologicalLeaveOfMonth - dataCommons.number_minutes_off_physiology_rest"
                    />
                  </CCol>
                  <CCol md="4" class="form-field mobile-input">
                    <label>
                      {{ $t("sabbatical.number_of_minutes_off_rest") }}
                    </label>
                    <CInput
                      type="text"
                      :disabled="true"
                      v-model="dataCommons.number_minutes_off_physiology_rest_real"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol md="12" class="form-field">
                    <label>
                      {{ $t("sabbatical.note") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required|max:512"
                      v-slot="{ errors }"
                      name="sabbatical.note"
                    >
                      <b-form-textarea
                        id="textarea"
                        rows="4"
                        max-rows="6"
                        v-model="forms.note"
                      ></b-form-textarea>
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="12" class="employees-form-sabbatical">
                    <CButton type="submit" class="save-info"
                      >{{ $t("label.save_infomation") }}
                    </CButton>
                    <CButton
                      class="cancel-employee"
                      type="button"
                      @click="cancel()"
                      >{{ $t("commons.cancel") }}
                    </CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </ValidationObserver>
  </CContainer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import moment from "moment";
import DatePickerForm from "@/components/commons/DatePickerForm";

export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_sabbatical_request_create"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },

  components: {
    ValidationObserver,
    ValidationProvider,
    DatePickerForm,
  },
  computed: {
    ...mapGetters({
      dataCommons: "sabbatical-leave-request/dataCommons",
      reasons: "sabbatical-leave-request/reasons",
      approveEmployees: "commons/approvalPersonList",
      timeWeekend: "sabbatical-leave-request/timeWeekend",
      account: "auth/account",
      admins: "commons/admins"
    }),
    reasonsFilter: function() {
      if(this.account.gender === this.male) {
        return this.reasons.filter(e => {
          return e.code !== "PHYSIOLOGY"
        })
      }
      return this.reasons;
    },
    minShiftDuration: function() {
      if (!this.account || !this.account.work_shift || 
          !this.account.work_shift.morning_shift_start || 
          !this.account.work_shift.morning_shift_end ||
          !this.account.work_shift.afternoon_shift_start ||
          !this.account.work_shift.afternoon_shift_end) {
        return 0.5; // Default fallback
      }
      
      // If start_date and end_date are different, return 0.5 (multi-day leave)
      if (this.forms.start_date && this.forms.end_date && 
          this.forms.start_date !== this.forms.end_date) {
        return 0.5;
      }
      
      // If start_time or end_time is not set, return 0.5
      if (!this.forms.start_time || !this.forms.end_time) {
        return 0.5;
      }
      
      const morningStart = this.timeToDecimal(this.account.work_shift.morning_shift_start);
      const morningEnd = this.timeToDecimal(this.account.work_shift.morning_shift_end);
      const afternoonStart = this.timeToDecimal(this.account.work_shift.afternoon_shift_start);
      const afternoonEnd = this.timeToDecimal(this.account.work_shift.afternoon_shift_end);
      
      // Convert start_time and end_time to decimal
      const startTimeDecimal = this.timeToDecimal(this.forms.start_time);
      const endTimeDecimal = this.timeToDecimal(this.forms.end_time);
      
      // Check if time range is fully within morning shift
      if (startTimeDecimal >= morningStart && endTimeDecimal <= morningEnd) {
        return Math.round(((morningEnd - morningStart) / this.working_time_of_day) * 100) / 100;
      }
      
      // Check if time range is fully within afternoon shift
      if (startTimeDecimal >= afternoonStart && endTimeDecimal <= afternoonEnd) {
        return Math.round(((afternoonEnd - afternoonStart) / this.working_time_of_day) * 100) / 100;
      }
      
      // If time range spans multiple shifts or is outside shifts, return 0.5
      return 0.5;
    },
    // April 4th is when the remaining leave from the previous year is reset
    maxDateBeforeApril4: function() {
      const today = moment(new Date());
      const currentYear = today.year();
      const aprilFourth = moment(`${currentYear}-04-04`, 'YYYY-MM-DD');
      
      if (today.isBefore(aprilFourth, 'day')) {
        const aprilThird = moment(`${currentYear}-04-03`, 'YYYY-MM-DD');
        return aprilThird.format('DD/MM/YYYY');
      }
      return null;
    }
  },
  data() {
    return {
      time_8_h: 8, // 8H00
      time_12_h: 12, // 12H00
      time_13_h_30_m: 13.5, // 13H30
      time_17_h_30_m: 17.5, // 17H30
      time_1_h_30m: 1.5, // 1H30
      working_time_of_day: 8,
      forms: {
        approve_person_1: null,
        approve_person_2: null,
        reason_code: "",
        reason_type: "",
        start_time: "08:00",
        end_time: "17:30",
        start_date: moment(new Date()).format("DD/MM/YYYY"),
        end_date: moment(new Date()).format("DD/MM/YYYY"),
        number_days_off: 0,
        note: null,
        numberDaysOffRest: null,
        allTimeDaysOffSabbatical: null,
        number_of_days_leave: null,
      },
      male: 1,
      female: 2,
      numberMinutesPhysiologicalLeaveOfMonth: 90

    };
  },

  async created() {
    let params = this.$route.query;
    if (params?.date) {
      this.forms.start_date = params.date;
      this.forms.end_date = params.date;
    }
    this.forms.start_time = this.account.work_shift.morning_shift_start.slice(0, 5);
    this.forms.end_time =this.account.work_shift.afternoon_shift_end.slice(0, 5);
    this.time_8_h = this.timeToDecimal(this.account.work_shift.morning_shift_start);
    this.time_12_h = this.timeToDecimal(this.account.work_shift.morning_shift_end);
    this.time_13_h_30_m = this.timeToDecimal(this.account.work_shift.afternoon_shift_start);
    this.time_17_h_30_m = this.timeToDecimal(this.account.work_shift.afternoon_shift_end);
    this.time_1_h_30m = this.time_13_h_30_m - this.time_12_h;
    
    this.$root.$loading.start();
    await this.$store.dispatch("sabbatical-leave-request/getDataCommons");
    await this.$store.dispatch("commons/getApprovePersonBySetting");
    this.forms.approve_person_1 = this.approveEmployees["level1"][0]
      ? this.approveEmployees["level1"][0]["id"]
      : "";
    if (
      this.approveEmployees["level2"] &&
      this.approveEmployees["level2"].length > 0
    ) {
      this.forms.approve_person_2 = this.approveEmployees["level2"][0]["id"];
    }
    this.$root.$loading.finish();
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),
    startDate(data) {
      this.forms.start_date = data;
      // Convert date from DD/MM/YYYY to YYYY-MM-DD format
      if (data && this.account.work_shift_list) {
        const dateMoment = moment(data, "DD/MM/YYYY", true);
        if (dateMoment.isValid()) {
          const dateKey = dateMoment.format("YYYY-MM-DD");
          let workShift = this.account.work_shift_list[dateKey];
          // If dateKey doesn't exist, use work_shift_default
          if (!workShift && this.account.work_shift_list['work_shift_default']) {
            workShift = this.account.work_shift_list['work_shift_default'];
          }
          if (workShift) {
            this.account.work_shift.morning_shift_start = workShift.morning_shift_start;
            this.account.work_shift.morning_shift_end = workShift.morning_shift_end;
            // Update time variables
            this.time_8_h = this.timeToDecimal(this.account.work_shift.morning_shift_start);
            this.time_12_h = this.timeToDecimal(this.account.work_shift.morning_shift_end);
            // Update form start_time
            this.forms.start_time = this.account.work_shift.morning_shift_start.slice(0, 5);
          }
        }
      }
      this.calculateDaySabbatical();
    },
    endDate(data) {
      this.forms.end_date = data;
      // Convert date from DD/MM/YYYY to YYYY-MM-DD format
      if (data && this.account.work_shift_list) {
        const dateMoment = moment(data, "DD/MM/YYYY", true);
        if (dateMoment.isValid()) {
          const dateKey = dateMoment.format("YYYY-MM-DD");
          let workShift = this.account.work_shift_list[dateKey];
          // If dateKey doesn't exist, use work_shift_default
          if (!workShift && this.account.work_shift_list['work_shift_default']) {
            workShift = this.account.work_shift_list['work_shift_default'];
          }
          if (workShift) {
            this.account.work_shift.afternoon_shift_start = workShift.afternoon_shift_start;
            this.account.work_shift.afternoon_shift_end = workShift.afternoon_shift_end;
            // Update time variables
            this.time_13_h_30_m = this.timeToDecimal(this.account.work_shift.afternoon_shift_start);
            this.time_17_h_30_m = this.timeToDecimal(this.account.work_shift.afternoon_shift_end);
            this.time_1_h_30m = this.time_13_h_30_m - this.time_12_h;
            // Update form end_time
            this.forms.end_time = this.account.work_shift.afternoon_shift_end.slice(0, 5);
          }
        }
      }
      this.calculateDaySabbatical();
    },
    async createSabbaticalRequest() {
      if (
        this.forms.number_days_off >
          this.dataCommons.all_time_days_off_sabbatical_rest_real &&
        this.forms.reason_type === "1"
      ) {
        return false;
      }
      this.$root.$loading.start();
      this.forms.numberDaysOffRest = this.dataCommons.number_of_days_off_rest;
      this.forms.number_of_days_leave = this.dataCommons.number_of_days_leave;
      this.forms.allTimeDaysOffSabbaticalRest =
        this.dataCommons.all_time_days_off_sabbatical_rest * 1 +
        this.forms.number_days_off * 1;
      await this.$store
        .dispatch(
          "sabbatical-leave-request/createSabbaticalRequest",
          this.forms
        )
        .then(() => {
          let message = this.$t("sabbatical.message_create_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$router.push({ path: "/sabbatical-leave-request" });
          this.$root.$loading.finish();
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },

    cancel() {
      this.$confirmModal(
        this.$t("popup.employee.label_popup_title"),
        this.$t("popup.sabbatical.label_popup_title_create_cancel"),
        this.$t("popup.employee.label_confirm_button"),
        this.$t("popup.employee.label_cancel_button"),
        "danger"
      ).then((value) => {
        if (value) {
          this.$router.push({ path: "/sabbatical-leave-request" });
        }
      });
    },

    async calculateDaySabbatical() {
      if (
        this.forms.start_date &&
        this.forms.end_date &&
        this.forms.start_time &&
        this.forms.end_time
      ) {
        let start_date_check = moment(
          this.forms.start_date,
          "DD/MM/YYYY",
          true
        );
        let end_date_check = moment(this.forms.end_date, "DD/MM/YYYY", true);
        let start_time_check = moment(this.forms.start_time, "HH:mm", true);
        let end_time_check = moment(this.forms.end_time, "HH:mm", true);
        if (
          start_date_check.isValid() &&
          end_date_check.isValid() &&
          start_time_check.isValid() &&
          end_time_check.isValid()
        ) {
          await this.$store.dispatch(
            "sabbatical-leave-request/getCalculateDayLeave",
            {
              end_time: this.forms.end_time,
              start_time: this.forms.start_time,
              start_date: this.forms.start_date,
              end_date: this.forms.end_date,
            }
          );
          let start_date = this.forms.start_date.split("/");
          let end_date = this.forms.end_date.split("/");
          let start_time = this.forms.start_time.split(":");
          let end_time = this.forms.end_time.split(":");
          let hours_start_time = start_time[0] * 1 + start_time[1] / 60;
          let hours_end_time = end_time[0] * 1 + end_time[1] / 60;
          let startDate = new Date(
            start_date[2],
            start_date[1] - 1,
            start_date[0]
          ).getTime();
          let endDate = new Date(
            end_date[2],
            end_date[1] - 1,
            end_date[0]
          ).getTime();
          let sumDate = (endDate - startDate) / 86400000;
          if (this.forms.start_date === this.forms.end_date) {
            this.calculateDaySabbaticalInDay(hours_start_time, hours_end_time);
          } else {
            this.calculateDaySabbaticalDifferentDay(
              hours_start_time,
              hours_end_time,
              sumDate
            );
          }
        }
      } else {
        this.forms.number_days_off = 0;
      }
    },


    calculateDaySabbaticalInDay(hours_start_time, hours_end_time) {
      if (
        hours_start_time >= this.time_8_h &&
        hours_start_time <= this.time_12_h &&
        hours_end_time >= this.time_13_h_30_m &&
        hours_start_time <= this.time_17_h_30_m
      ) {
        this.forms.number_days_off =
          (this.time_12_h -
            hours_start_time +
            (hours_end_time - this.time_13_h_30_m)) /
          this.working_time_of_day;
      }

      if (
        (hours_start_time >= this.time_8_h &&
          hours_end_time <= this.time_12_h) ||
        (hours_start_time >= this.time_13_h_30_m &&
          hours_end_time <= this.time_17_h_30_m)
      ) {
        this.forms.number_days_off =
          (hours_end_time - hours_start_time) / this.working_time_of_day;
      }
        //get 2 digit after dot
      var tmp = 100;
      if(this.forms.reason_type == 4) {
        //get 3 digit after dot
        tmp = 1000;
      }
      this.forms.number_days_off =
        Math.round(this.forms.number_days_off * tmp) / tmp - this.timeWeekend;
      if (this.forms.number_days_off < 0) {
        this.forms.number_days_off = 0;
      }
      this.$nextTick(function () {
        this.$refs.numberDaysOff.validate();
      });
    },

    calculateDaySabbaticalDifferentDay(
      hours_start_time,
      hours_end_time,
      sumDate
    ) {
      if (
        hours_start_time >= this.time_8_h &&
        hours_start_time <= this.time_12_h &&
        hours_end_time >= this.time_13_h_30_m &&
        hours_end_time <= this.time_17_h_30_m
      ) {
        this.forms.number_days_off =
          sumDate -
          1 +
          (this.time_17_h_30_m -
            hours_start_time -
            this.time_1_h_30m +
            (hours_end_time - this.time_8_h - this.time_1_h_30m)) /
            this.working_time_of_day;
      }

      if (
        hours_end_time >= this.time_8_h &&
        hours_end_time <= this.time_12_h &&
        hours_start_time >= this.time_13_h_30_m &&
        hours_start_time <= this.time_17_h_30_m
      ) {
        this.forms.number_days_off =
          sumDate -
          1 +
          (this.time_17_h_30_m -
            hours_start_time +
            (hours_end_time - this.time_8_h)) /
            this.working_time_of_day;
      }

      if (
        hours_start_time >= this.time_8_h &&
        hours_start_time <= this.time_12_h &&
        hours_end_time >= this.time_8_h &&
        hours_end_time <= this.time_12_h
      ) {
        this.forms.number_days_off =
          sumDate -
          1 +
          (this.time_17_h_30_m -
            hours_start_time -
            this.time_1_h_30m +
            (hours_end_time - this.time_8_h)) /
            this.working_time_of_day;
      }

      if (
        hours_end_time >= this.time_13_h_30_m &&
        hours_end_time <= this.time_17_h_30_m &&
        hours_start_time >= this.time_13_h_30_m &&
        hours_start_time <= this.time_17_h_30_m
      ) {
        this.forms.number_days_off =
          sumDate -
          1 +
          (this.time_17_h_30_m -
            hours_start_time +
            (hours_end_time - this.time_8_h - this.time_1_h_30m)) /
            this.working_time_of_day;
      }
      this.forms.number_days_off =
        Math.round(this.forms.number_days_off * 100) / 100 - this.timeWeekend;
      if (this.forms.number_days_off < 0) {
        this.forms.number_days_off = 0;
      }
      this.$nextTick(function () {
        this.$refs.numberDaysOff.validate();
      });
    },

    linkToGuide() {
      this.$store.dispatch("commons/setLeaveValue");
      this.$router.push({ path: "/note/document" });
    },

    changeReasonTypeToPhysiologicalLeave() {
      this.calculateDaySabbatical();
      if(this.forms.reason_type == 4) {
        //approval person
        this.forms.approve_person_1 = this.admins[0]?.id;
        this.forms.approve_person_2 = "";
        //time end
        this.forms.end_time = "09:30";

      }else{
         //approval person
        this.forms.approve_person_1 = this.approveEmployees?.level1[0]?.id;
        this.forms.approve_person_2 = this.approveEmployees?.level2[0]?.id;
        this.forms.end_time = this.account.work_shift.afternoon_shift_end.slice(0, 5);
      }
      // Update start_time according to account.work_shift.morning_shift_start
      this.forms.start_time = this.account.work_shift.morning_shift_start.slice(0, 5);
    },

    timeToDecimal(time) {
      const [hour, minute] = time.split(':').map(Number);
      return hour + minute / 60;
    }
  },
};
</script>
